import { StaticLink } from '@silvertours/common-landingpages-view';
import { useLogin } from '@silvertours/front-features';
import { Benefit } from 'common/landingpages/i18n/src/features/NavigationLegacy';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

export const useHeader = () => {
  const t = useTranslations('features.navigationLegacy.navigation');
  const openingTimesTooltip = useTranslations('features.supportInfoLegacy')(
    'openingTimes.tooltip.title',
  );
  const router = useRouter();
  const { error: loginError } = useLogin();

  const translations = {
    loginButton: {
      accountLinks: {
        myBookings: {
          text: t('login.button.authenticated.menu.myBookings.text'),
          href: t('login.button.authenticated.menu.myBookings.href'),
        },
        myData: {
          text: t('login.button.authenticated.menu.myData.text'),
          href: t('login.button.authenticated.menu.myData.href'),
        },
        myPayment: {
          text: t('login.button.authenticated.menu.myPayment.text'),
          href: t('login.button.authenticated.menu.myPayment.href'),
        },
        logout: {
          text: t('logout.text'),
          href: t('logout.href'),
        },
      },
      account: t('login.button.account'),
      label: t('login.button.label'),
    },
    loginModal: {
      actionPath: t('login.href', {
        redirectPath: encodeURIComponent(router.asPath),
      }),
      error: {
        headline: loginError ? t(`login.error.${loginError}Title`) : '',
        message: loginError ? t(`login.error.${loginError}`) : '',
        passwordLostHref: t('passwordLost.href'),
        passwordLostLabel: t('login.error.resetPasswordLink'),
        resendConfirmUser: t('login.error.resendConfirmUser'),
      },
      emailLabel: t('login.emailLabel'),
      loginTitle: t('login.title'),
      loginButtonText: t('login.buttonText'),
      newUserHref: t('newUser.href'),
      newUserText: t('newUser.text'),
      noAccountText: t('login.noAccountText'),
      passwordLabel: t('login.passwordLabel'),
      passwordLostHref: t('passwordLost.href'),
      passwordLostText: t('passwordLost.text'),
      submitText: t('login.submitText'),
    },
    closeMenuLabel: t('header.closeLabel'),
    menuLabel: t('header.menuLabel'),
    openingTimesTooltip,
    membership: {
      welcomeSubtitle: t('login.membership.welcomeSubtitle'),
      loginButton: t('login.membership.loginButton'),
      joinButton: t('login.membership.joinButton'),
      benefitsSubtitle: t('login.membership.benefitsSubtitle'),
      benefits: t.raw('login.membership.benefits') as Benefit,
      signUpLink: t('newUser.href'),
      moreInfoLink: {
        text: t('login.membership.moreInfoLink.text'),
        href: t('login.membership.moreInfoLink.href'),
      },
    },
  };

  return {
    getLinks: (staticLinks: StaticLink[]) =>
      staticLinks.filter(({ type }) => type === 'main'),
    translations,
  };
};
